export const INIT = 'app/DeedPage/INIT';
export const INIT_SUCCESS = 'app/DeedPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DeedPage/INIT_FAILED';

export const CANCEL = 'app/DeedPage/CANCEL';
export const CANCEL_SUCCESS = 'app/DeedPage/CANCEL_SUCCESS';
export const CANCEL_FAILED = 'app/DeedPage/CANCEL_FAILED';

export const CHECK_IN_ATTENDEE = 'app/DeedPage/CHECK_IN_ATTENDEE';
export const CHECK_IN_ATTENDEE_SUCCESS = 'app/DeedPage/CHECK_IN_ATTENDEE_SUCCESS';
export const CHECK_IN_ATTENDEE_FAILED = 'app/DeedPage/CHECK_IN_ATTENDEE_FAILED';

export const REMOVE_ATTENDEE = 'app/DeedPage/REMOVE_ATTENDEE';
export const REMOVE_ATTENDEE_SUCCESS = 'app/DeedPage/REMOVE_ATTENDEE_SUCCESS';
export const REMOVE_ATTENDEE_FAILED = 'app/DeedPage/REMOVE_ATTENDEE_FAILED';

export const EMAIL_ATTENDEES = 'app/DeedPage/EMAIL_ATTENDEES';
export const EMAIL_ATTENDEES_SUCCESS = 'app/DeedPage/EMAIL_ATTENDEES_SUCCESS';
export const EMAIL_ATTENDEES_FAILED = 'app/DeedPage/EMAIL_ATTENDEES_FAILED';

export const SET_USER_ROLE_STATUS = 'app/DeedPage/SET_USER_ROLE_STATUS';
export const SET_USER_ROLE_STATUS_SUCCESS = 'app/DeedPage/SET_USER_ROLE_STATUS_SUCCESS';
export const SET_USER_ROLE_STATUS_FAILED = 'app/DeedPage/SET_USER_ROLE_STATUS_FAILED';

export const TOGGLE_EMAIL_ATTENDEES_OVERLAY = 'app/DeedPage/TOGGLE_EMAIL_ATTENDEES_OVERLAY';
export const TOGGLE_ADD_ATTENDEES_OVERLAY = 'app/DeedPage/TOGGLE_ADD_ATTENDEES_OVERLAY';
export const TOGGLE_INVITE_ATTENDEES_OVERLAY = 'app/DeedPage/TOGGLE_INVITE_ATTENDEES_OVERLAY';
export const TOGGLE_FORM_RESPONSES_OVERLAY = 'app/DeedPage/TOGGLE_FORM_RESPONSES_OVERLAY';
export const TOGGLE_FORM_AGGREGATIONS_OVERLAY = 'app/DeedPage/TOGGLE_FORM_AGGREGATIONS_OVERLAY';

export const REMOVE_INVITEE = 'app/DeedPage/REMOVE_INVITEE';
export const REMOVE_INVITEE_SUCCESS = 'app/DeedPage/REMOVE_INVITEE_SUCCESS';
export const REMOVE_INVITEE_FAILED = 'app/DeedPage/REMOVE_INVITEE_FAILED';

export const COMPLETE_MILESTONE = 'app/DeedPage/COMPLETE_MILESTONE';
export const COMPLETE_MILESTONE_SUCCESS = 'app/DeedPage/COMPLETE_MILESTONE_SUCCESS';
export const COMPLETE_MILESTONE_FAILED = 'app/DeedPage/COMPLETE_MILESTONE_FAILED';

export const GET_VOLUNTEER_TIMES = 'app/DeedPage/GET_VOLUNTEER_TIMES';
export const APPROVE_VOLUNTEER_TIME = 'app/DeedPage/APPROVE_VOLUNTEER_TIME';
export const DENY_VOLUNTEER_TIME = 'app/DeedPage/DENY_VOLUNTEER_TIME';
export const RESPOND_VOLUNTEER_TIME_SUCCESS = 'app/DeedPage/RESPOND_VOLUNTEER_TIME_SUCCESS';
export const RESPOND_VOLUNTEER_TIME_FAILED = 'app/DeedPage/RESPOND_VOLUNTEER_TIME_FAILED';

export const SET_PROJECT_STARTED = 'app/DeedPage/SET_PROJECT_STARTED';
export const SET_PROJECT_STARTED_SUCCESS = 'app/DeedPage/SET_PROJECT_STARTED_SUCCESS';
export const SET_PROJECT_STARTED_FAILED = 'app/DeedPage/SET_PROJECT_STARTED_FAILED';

export const SET_OPT_IN_STATUS = 'app/DeedPage/SET_OPT_IN_STATUS';
export const SET_OPT_IN_STATUS_SUCCESS = 'app/DeedPage/SET_OPT_IN_STATUS_SUCCESS';
export const SET_OPT_IN_STATUS_FAILED = 'app/DeedPage/SET_OPT_IN_STATUS_FAILED';
